import React from 'react';
import SEO from './SEO';
import { RouteMeta } from '../content/tools';

interface RouteSeoProps {
  route: RouteMeta;
  /** Overrides the default index,follow directive (used by the tools index). */
  robots?: string;
}

/**
 * Applies a route's metadata from src/content/tools.json to document.head.
 * Using this instead of hand-written tags keeps every page's client-side head
 * identical to the prerendered HTML built by scripts/prerender.mjs.
 */
const RouteSeo: React.FC<RouteSeoProps> = ({ route, robots }) => (
  <SEO
    title={route.title}
    description={route.description}
    path={route.path}
    keywords={route.keywords}
    robots={robots}
  />
);

export default RouteSeo;
